// Lights.js
import * as THREE from 'three';

import EventDispatcher from '../common/EventDispatcher';
import { Global } from '../common/global';
import { isMobile } from 'mobile-device-detect';

export default class Lights {
  constructor(scene, camera, renderer) {
    this.scene = scene;
    this.camera = camera;
    this.renderer = renderer;

    this.lights = []; // keep references to all lights
    this.helpers = {}; // keep references to helpers if needed

    this.keeperOffset = new THREE.Vector3(0, 5, 0);
    this.keeperTargetOffset = new THREE.Vector3(0, 4, 0);

    this.onEvents = this.onEvents.bind(this);
  }

  init(gui) {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents);
    this.events.addEventListener('GAME_EVENTS', this.onEvents);

    // const dirLight = new THREE.PointLight(0xffffff, 200, 100, 0.0);
    // dirLight.position.set(10, 20, 10);
    // dirLight.castShadow = true;

    this.shadowLight = new THREE.DirectionalLight(0xffffff, 2.1); // Color, Intensity (low intensity since it's only for shadows)

    this.ambientLight = new THREE.AmbientLight(0xffffff, 0.2);
    // Set the light's position and target.
    // The direction from the position to the target determines the shadow angle.
    this.shadowLight.position.set(0, 50, 0);
    this.shadowLight.target.position.set(0, 0, 0); // Pointing towards the center of the scene
    this.shadowLight.castShadow = true;
    this.scene.add(this.shadowLight);
    this.scene.add(this.ambientLight);
    this.scene.add(this.shadowLight.target);
    // this.shadowLight.shadow.bias = -0.0001;
    this.shadowLight.shadow.normalBias = 0.027;
    this.shadowLight.shadow.bias = isMobile ? -0.0004 : -0.0002;

    const frustumSize = isMobile ? 50 : 100; // Example: Adjust based on your scene size

    const shadowCamera = this.shadowLight.shadow.camera;
    shadowCamera.left = -frustumSize;
    shadowCamera.right = frustumSize;
    shadowCamera.top = frustumSize;
    shadowCamera.bottom = -frustumSize;

    // const helper = new THREE.CameraHelper(this.shadowLight.shadow.camera);
    // this.scene.add(helper);

    this.shadowLight.shadow.mapSize.width = 1024 * (isMobile ? 0.75 : 3);
    this.shadowLight.shadow.mapSize.height = 1024 * (isMobile ? 0.75 : 3);

    this.lights.push(this.shadowLight);
    this.lights.push(this.ambientLight);
  }

  onEvents(data) {
    const msgType = data?.message?.event_type;
    switch (msgType) {
      case 'dispose':
        this.dispose();
        break;
      case 'update':
        this.update(data['message']['data']);
        break;
      default:
        break;
    }
  }

  update() {
    if (Global.playerPos) {
      const playerPosition = Global.playerPos;

      // Center the light's shadow camera on the player's X and Z coordinates
      this.shadowLight.position.x = playerPosition.x + 50;
      this.shadowLight.position.z = playerPosition.z + 50;

      // Tell the light to look at the player's position (or slightly behind it)
      this.shadowLight.target.position.x = playerPosition.x;
      this.shadowLight.target.position.z = playerPosition.z;
    }
  }
  dispose() {
    // Remove all lights from scene
    this.lights.forEach((light) => {
      this.scene.remove(light);

      // If light has shadow maps, free them
      if (light.shadow && light.shadow.map) {
        light.shadow.map.dispose();
      }

      // Some lights have target objects
      if (light.target) {
        this.scene.remove(light.target);
      }
    });

    // Dispose helpers if any
    Object.values(this.helpers).forEach((helper) => {
      if (helper) {
        this.scene.remove(helper);
        if (helper.dispose) helper.dispose();
      }
    });

    // Clear references
    this.lights = [];
    this.helpers = {};

    if (this.events) {
      this.events.removeEventListener('GAMESCENE_EVENTS', this.onEvents);
      this.events.removeEventListener('GAME_EVENTS', this.onEvents);
    }
  }
}
